const mutations = {
  GET_TOP_HAT_DATA(state, data) {
    state.topHatData = data;
  },
};

export default mutations;
